import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  TIP_BANNER: `${cleanedFilename(__filename)}-tip-banner`,
};
